import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function CartPage() {
  const { cart, removeFromCart, clearCart } = useContext(CartContext);

  const total = cart.reduce(
    (sum, item) => sum + parseFloat(item.price) * item.qty,
    0
  );

  return (
    <div className="cart-page">
      <h2>Your Cart</h2>
      {cart.length === 0 ? (
        <p>Cart is empty</p>
      ) : (
        <>
          <ul>
            {cart.map((item) => (
              <li key={item.id}>
                {item.name} x {item.qty} = {item.price * item.qty}{" "}
                <button onClick={() => removeFromCart(item.id, item.name)}>Remove</button>
              </li>
            ))}
          </ul>
          <h3>Total: {total.toFixed(2)}</h3>
          <button onClick={clearCart}>Clear Cart</button>
          <br />
          <Link to="/checkout">
            <button>Go to Checkout</button>
          </Link>
        </>
      )}
    </div>
  );
}

export default CartPage;
